import { validPanelNumber } from "./PanelNumberRegex";

/**
 * Function to convert a UTP2 PanelNo to a number. Panel Numbers with leading zeros are treated as negative numbers
 * and a Subset (Panel Number with a trailing 'A') have a value of 0.1 added to the number.
 * NaN is returned if the provided panel number doesn't conform with the UTP2 device regular expression /^[0-9]{1,2}[A]?$/.
 * @param panelNo The UTP2 Panel Number
 * @returns The numeric value for the UTP2 Panel Number.
 */
export function convertUTP2PanelNoStringToNumber(panelNo: string) {
  if (!validPanelNumber(panelNo)) return NaN;
  else return Number(panelNo.replace("A", "").replace(/^0+(?!$)/, "-")) + (panelNo.includes("A") ? 0.1 : 0);
}

/**
 * Function to convert a number to a UTP2 PanelNo. Negative numbers will be preceded with a zero
 * and a Subset (numbers offset by 0.1) will be rounded and a trailing 'A' will be added.
 * @param num A number
 * @returns The numeric value converted to a string following the UTP2 Panel Number format.
 */
export function convertNumberToUTP2PanelNoString(num: number) {
  return `${Math.round(num).toString().replace("-", "0")}${num % 1 !== 0 ? "A" : ""}`;
}
